export default "__VITE_ASSET__D5PaEJ3F__"